import { render } from "./ScpmTagDropdown.vue?vue&type=template&id=70f81f1c&scoped=true"
import script from "./ScpmTagDropdown.vue?vue&type=script&lang=js"
export * from "./ScpmTagDropdown.vue?vue&type=script&lang=js"

import "./ScpmTagDropdown.vue?vue&type=style&index=0&id=70f81f1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f81f1c"],['__file',"src/components/scpm/common/ScpmTagDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70f81f1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70f81f1c', __exports__)) {
    api.reload('70f81f1c', __exports__)
  }
  
  module.hot.accept("./ScpmTagDropdown.vue?vue&type=template&id=70f81f1c&scoped=true", () => {
    api.rerender('70f81f1c', render)
  })

}


export default __exports__